import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import * as Sentry from "@sentry/nextjs";

import { resources, NAMESPACES } from "./resources";
import {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
} from "./types";

import "./types";

const isProduction = process.env.NODE_ENV === "production";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns: [...NAMESPACES],
    defaultNS: "common",
    // SSR/CSR 초기 렌더 언어를 일치시켜 하이드레이션 오류를 방지한다.
    // lng 가 명시되면 LanguageDetector 는 init 시 감지를 건너뛰므로
    // 마운트 후 useLocale effect 에서 localStorage 를 읽어 실제 언어로 전환한다.
    lng: DEFAULT_LANGUAGE,
    fallbackLng: {
      ja: ["ko", "en"],
      km: ["ko", "en"],
      en: ["ko"],
      default: [DEFAULT_LANGUAGE],
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      // localStorage 쓰기는 changeLocaleState 에서 명시적으로 관리한다.
      // caches 를 남기면 init 시 lng:'ko' 로 인한 languageChanged 이벤트가
      // 기존에 저장된 ja/km 값을 'ko' 로 덮어써 reload 시 언어가 초기화된다.
      caches: [],
      convertDetectedLanguage: (lng) => {
        const short = lng.split("-")[0].toLowerCase();
        return (SUPPORTED_LANGUAGES as readonly string[]).includes(short)
          ? short
          : DEFAULT_LANGUAGE;
      },
    },
    saveMissing: !isProduction,
    missingKeyHandler: (lngs, ns, key) => {
      if (!isProduction) {
        console.warn(
          `[i18n missing] ns=${ns} key=${key} lng=${(lngs as readonly string[]).join(",")}`
        );
        return;
      }
      Sentry.captureMessage("i18n missing key", {
        level: "warning",
        extra: { ns, key, lngs },
      });
    },
  });

export default i18n;
